module.exports = __webpack_public_path__ + "static/media/landmark-sponsor.cd8e8705.png";